//import axios from "../../plugins/axios";
// eslint-disable-next-line
import { axiosInstance } from '@plugins/axios';

// initial state
export const state = {

}

// getters
export const getters = {

}

// actions
export const actions = {

}

// mutations
export const mutations = {

}